import script from "./ProspeccaoChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspeccaoChart.vue?vue&type=script&setup=true&lang=js"

import "./ProspeccaoChart.vue?vue&type=style&index=0&id=f7e6086e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e6086e"]])

export default __exports__